<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>

            <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">所属单位</template>
                    {{ detail.company ? detail.company.name : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">所属部门</template>
                    {{ detail.dept ? detail.dept.name : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">姓名</template>
                    {{ detail.name }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">年龄</template>
                    {{ detail.age }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">身份证号码</template>
                    {{ detail.id_number }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">学号</template>
                    {{ detail.student_number }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">电话</template>
                    {{ detail.mobile }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">是否实名认证</template>
                    {{ detail.is_certification_desc }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">认证时间</template>
                    {{ detail.certification_time }}
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form">扩展信息</div>

            <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
                <el-descriptions-item v-for="(item, index) in detail.user_fields" :key="index" >
                    <template slot="label">{{ item.field_name }}</template>
                    {{ item.field_value }}
                </el-descriptions-item>
            </el-descriptions>

<!--            <el-form-item v-for="(item, index) in detail.user_fields" :label="item.field_name" :key="index" prop="mobile">-->
<!--                <el-input v-model="form.user_fields[index].field_value" :placeholder="item.field_name" clearable/>-->
<!--            </el-form-item>-->


        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {companyUserEdit, getListChildrenTree, companyUserDetail} from '@/api/education';

    export default {
        components: { },
        data() {
            return {
                title: '详情',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                // 验证
                formRules: {
                    title: [{
                        required: true,
                        message: '请输入名称',
                        trigger: 'blur'
                    }]
                },
                form: {},
                member_id: '',
                detail: []
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'success'});
                } else {
                    this.member_id = row.member_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            save(){
                this.close()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            getDetail(){
                companyUserDetail({id: this.member_id}).then((result)=>{
                    this.detail = Object.assign({}, result.data)
                })
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/dept/dept/user-detail.vue